/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, input, InputSignal, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MapComponent } from './map/map.component';
import { ElevationComponent } from './elevation/elevation.component';
import { StatsComponent } from './stats/stats.component';

@Component({
    selector: "app-details-gpx-route",
    imports: [
        CommonModule,
        TranslateModule,
        MapComponent,
        ElevationComponent,
        StatsComponent
    ],  
    standalone: true,
    templateUrl: "./gpx-route.component.html",
    styleUrls: ["./gpx-route.component.scss"]
})

export class GpxRouteComponent {
    public gpxData: InputSignal<any> = input<any>();
    public coordinates: InputSignal<any> = input<any>();
    public gpxElevation = signal(null);
    public gpxStats = signal(null);
    public mapCoordinates: any;

    ngOnInit(){
        this.mapCoordinates = this.coordinates()?.lat && this.coordinates()?.lng 
            ? [this.coordinates().lat, this.coordinates().lng]
            : [40.4168, -3.7038]
    }

    handleReceivedElevation(elevation) {
        if (!elevation)
            return;

        this.gpxElevation.set(elevation);

        const distances = elevation?.map(p => p.distance);
        const elevations = elevation?.map(p => p.elevation);

        this.gpxStats.set({
            maxDistance: Math.max(...distances)?.toFixed(1),
            minElevation: Math.min(...elevations)?.toFixed(0),
            maxElevation: Math.max(...elevations)?.toFixed(0)
        })
    }
    
}